export default {
	props: {
		value: {
			required: false
		},
		needValidation: {
			type: Boolean,
			default: false
		},
		manualError: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			inputData: '',
			hasError: false
		};
	},

	template: `
		<label
			class="input-item"
			:class="{ 
				focused: inputData.length > 0,
				'input-item-error': hasError,
				'input-item--error': manualError
			}"
		>
			<svg v-if="!disabled" class="input-item__editable-icon" width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14.1489 23H10.1641C9.988 23 9.81907 22.93 9.69452 22.8055C9.56997 22.6809 9.5 22.512 9.5 22.3359V18.6262C9.5 18.5389 9.51718 18.4526 9.55055 18.372C9.58393 18.2914 9.63285 18.2182 9.69452 18.1565L19.6565 8.19452C19.7811 8.06997 19.95 8 20.1262 8C20.3023 8 20.4712 8.06997 20.5958 8.19452L24.3055 11.9042C24.43 12.0288 24.5 12.1977 24.5 12.3738C24.5 12.55 24.43 12.7189 24.3055 12.8435L14.1489 23Z" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M17.5 11L21.5 15" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			<input
				v-model="inputData"
				@blur="checkValidation"
				type="tel"
				@keydown="checkMask"
				:disabled="disabled"
			>
			<p 
				class="input-item__caption"
				:class="{'input-item__caption-error': hasError}"
			>{{ hasError ? 'Требуется указать корректный телефон' : 'Телефон*' }}</p>
			<span class="input-item__error" v-if="manualError">{{ manualError }}</span>
		</label>
	`,

	created() {
		this.hasError = this.needValidation ? !!this.value : false;
		if(!this.value) {
			return;
		}
		function phoneMask(phone) {
			const regex = /(\d?)(\d{3})(\d{3})(\d{2})(\d{2})/g;
			const subst = '$1 ($2) $3-$4-$5';
			return phone.replace(regex, subst);
		}
		this.inputData = phoneMask(this.value);
	},

	watch: {
		inputData() {
			this.checkValidation();
			setTimeout(() => {
				this.$emit('input-number', this.inputData.replace(/[^+\d]/g, ''));
			});
		}
	},

	methods: {
		checkMask(event) {
			if(!(event.key == 'ArrowLeft' || event.key == 'ArrowRight' || event.key == 'Backspace' || event.key == 'Tab')) {
				event.preventDefault();
			}

			const mask = '+7 (111) 111-11-11';

			if (/[0-9\+\ \-\(\)]/.test(event.key)) {
				let currentString = this.inputData;
				let currentLength = currentString.length;
				if (/[0-9]/.test(event.key)) {
					if (mask[currentLength] == '1') {
						this.inputData = currentString + event.key;
					} else {
						for (var i=currentLength; i<mask.length; i++) {
							if (mask[i] == '1') {
								this.inputData = currentString + event.key;
								break;
							}
							currentString += mask[i];
						}
					}
				}
			}
		},
		checkValidation() {
			if (this.inputData.replace(/[^+\d]/g, '').length < 12 && this.needValidation) {
				this.hasError = true;
				return;
			}

			this.hasError = false;
		}
	},
};
